import { iRequest } from '../../utils/requestutil';

export async function queryConfig(payload) {
  return iRequest(
    `/iwms-openapi/api/ignoreUpdateConfig/queryConfig?interfaceConfigUuid=${payload.interfaceConfigUuid}`,
    {
      method: 'GET',
    },
  );
}

export async function queryField(payload) {
  return iRequest(
    `/iwms-openapi/api/ignoreUpdateConfig/queryField?interfaceName=${payload.interfaceName}`,
    {
      method: 'GET',
    },
  );
}

export async function save(payload) {
  return iRequest(
    `/iwms-openapi/api/ignoreUpdateConfig?companyUuid=${payload.companyUuid}&interfaceConfigUuid=${payload.interfaceConfigUuid}`,
    {
      method: 'POST',
      body: payload.fields,
    },
  );
}

export async function get(payload) {
  return iRequest(
    `/iwms-openapi/api/uploadconfig?type=${payload.type}&interfaceConfigUuid=${payload.interfaceConfigUuid}`,
    {
      method: 'GET',
      // data: payload.fields,
    },
  );
}

export async function saveProcess(payload) {
  return iRequest(
    `/iwms-openapi/api/uploadconfig?limited=${payload.limited}&interfaceConfigUuid=${payload.interfaceConfigUuid}`,
    {
      method: 'POST',
      // data: payload.fields,
    },
  );
}
